var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.inPreview
    ? _c("div", [
        _vm.generatingPreview
          ? _c(
              "div",
              { staticClass: "relative" },
              [
                _c("b-skeleton", {
                  attrs: { animation: "fade", width: "100%", height: "60vh" }
                }),
                _c(
                  "div",
                  {
                    staticClass:
                      "absolute top-0 left-0 w-100 h-100 d-flex justify-center items-center gap-4"
                  },
                  [
                    _c("b-spinner"),
                    _c("span", [_vm._v("Generando previsualización")])
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _c("div", [
          !_vm.generatingPreview && _vm.pdfUrl !== "" && _vm.pdfUrl != null
            ? _c("iframe", {
                staticClass: "w-100",
                staticStyle: { height: "70vh" },
                attrs: {
                  src: _vm.pdfUrl,
                  name: "pdfPreviewIframe",
                  title: "pdfPreviewIframe"
                }
              })
            : _vm._e()
        ]),
        _c(
          "div",
          { staticClass: "row justify-end" },
          [
            _c(
              "vs-button",
              {
                staticClass: "mt-5 mr-5",
                attrs: { "data-cy": "cancel", color: "primary" },
                on: {
                  click: function($event) {
                    return _vm.backToForm()
                  }
                }
              },
              [_vm._v(" Volver ")]
            ),
            _c(
              "vs-button",
              {
                staticClass: "mt-5 mr-5",
                attrs: { "data-cy": "save", color: "success" },
                on: {
                  click: function($event) {
                    return _vm.save()
                  }
                }
              },
              [_vm._v(" Crear ")]
            )
          ],
          1
        )
      ])
    : _c("div", [
        _c(
          "form",
          {
            attrs: { "data-vv-scope": "custom-document", autocomplete: "off" },
            on: {
              submit: function($event) {
                $event.preventDefault()
              }
            }
          },
          [
            _c("h2", { staticClass: "mb-10" }, [
              _vm._v("Acta de fiscalización")
            ]),
            _c("h4", [_vm._v("Antecedentes generales")]),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c("sanitary-companies-list", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    ref: "sanitaryCompany",
                    attrs: {
                      danger: _vm.errors.has("custom-document.sanitaryCompany"),
                      "danger-text": _vm.errors.first(
                        "custom-document.sanitaryCompany"
                      ),
                      name: "sanitaryCompany",
                      label: "Empresa sanitaria *",
                      "data-vv-as": "empresa sanitaria"
                    },
                    on: {
                      "full-input": function($event) {
                        return _vm.setGeneratedData($event)
                      }
                    },
                    model: {
                      value: _vm.formData.sanitaryCompany,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "sanitaryCompany", $$v)
                      },
                      expression: "formData.sanitaryCompany"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c("regions-list", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    ref: "region",
                    attrs: {
                      danger: _vm.errors.has("custom-document.region"),
                      "danger-text": _vm.errors.first("custom-document.region"),
                      name: "region",
                      label: "Región *",
                      "data-vv-as": "región"
                    },
                    model: {
                      value: _vm.formData.region,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "region", $$v)
                      },
                      expression: "formData.region"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "Localidad *" } },
                    [
                      _c(
                        "v-select",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          class: {
                            "v-select-danger": _vm.errors.has(
                              "custom-document.location"
                            )
                          },
                          attrs: {
                            state: _vm.errors.has("custom-document.location")
                              ? false
                              : null,
                            "data-vv-as": "localidad",
                            name: "location",
                            placeholder: "Busque o ingrese una nueva localidad",
                            options: _vm.locationOptions,
                            taggable: ""
                          },
                          model: {
                            value: _vm.formData.location,
                            callback: function($$v) {
                              _vm.$set(_vm.formData, "location", $$v)
                            },
                            expression: "formData.location"
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              attrs: { slot: "no-options" },
                              slot: "no-options"
                            },
                            [
                              _vm._v(
                                "No hay localidades para el criterio de búsqueda"
                              )
                            ]
                          )
                        ]
                      ),
                      _vm.errors.has("custom-document.location")
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "con-text-validation span-text-validation-danger v-enter-to",
                              staticStyle: { height: "19px" }
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "span-text-validation" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.errors.first(
                                          "custom-document.location"
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "RUT *" } },
                    [
                      _c("b-form-input-rut", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|validateRut",
                            expression: "'required|validateRut'"
                          }
                        ],
                        attrs: {
                          id: "rut",
                          name: "rut",
                          autocomplete: "off",
                          "data-cy": "rut",
                          placeholder: "12345678-0",
                          state: _vm.errors.has("custom-document.rut")
                            ? false
                            : null,
                          "data-vv-as": "rut",
                          "truncate-value": ""
                        },
                        model: {
                          value: _vm.formData.rut,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "rut", $$v)
                          },
                          expression: "formData.rut"
                        }
                      }),
                      _vm.errors.has("custom-document.rut")
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "con-text-validation span-text-validation-danger v-enter-to",
                              staticStyle: { height: "19px" }
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "span-text-validation" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.errors.first("custom-document.rut")
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: { label: "Identificación instalación sanitaria *" }
                    },
                    [
                      _c("b-form-textarea", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass: "mb-2",
                        attrs: {
                          state: _vm.errors.has(
                            "custom-document.identification"
                          )
                            ? false
                            : null,
                          name: "identification",
                          "data-cy": "identification",
                          "data-vv-as": "identificación instalación sanitaria",
                          type: "text",
                          rows: "3",
                          maxLength: "1000"
                        },
                        on: {
                          input: function() {
                            return (_vm.formData.identification = _vm.formData.identification.toUpperCase())
                          }
                        },
                        model: {
                          value: _vm.formData.identification,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "identification", $$v)
                          },
                          expression: "formData.identification"
                        }
                      }),
                      _c("div", { staticClass: "text-right" }, [
                        _c(
                          "small",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: "Contador de caracteres",
                                expression: "'Contador de caracteres'"
                              }
                            ]
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.formData.identification.length) +
                                "/1000 "
                            )
                          ]
                        )
                      ]),
                      _vm.errors.has("custom-document.identification")
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "con-text-validation span-text-validation-danger v-enter-to",
                              staticStyle: { height: "19px" }
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "span-text-validation" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.errors.first(
                                          "custom-document.identification"
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "Dirección/Ubicación instalación *" } },
                    [
                      _c("b-form-textarea", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: {
                          state: _vm.errors.has("custom-document.address")
                            ? false
                            : null,
                          name: "address",
                          "data-cy": "address",
                          "data-vv-as": "dir/ubi instalación",
                          type: "text",
                          rows: "3",
                          maxLength: "1000"
                        },
                        on: {
                          input: function() {
                            return (_vm.formData.address = _vm.formData.address.toUpperCase())
                          }
                        },
                        model: {
                          value: _vm.formData.address,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "address", $$v)
                          },
                          expression: "formData.address"
                        }
                      }),
                      _c("div", { staticClass: "text-right" }, [
                        _c(
                          "small",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: "Contador de caracteres",
                                expression: "'Contador de caracteres'"
                              }
                            ]
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.formData.address.length) +
                                "/1000 "
                            )
                          ]
                        )
                      ]),
                      _vm.errors.has("custom-document.address")
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "con-text-validation span-text-validation-danger v-enter-to",
                              staticStyle: { height: "19px" }
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "span-text-validation" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.errors.first(
                                          "custom-document.address"
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "Nombre responsable empresa *" } },
                    [
                      _c("b-form-textarea", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: {
                          state: _vm.errors.has(
                            "custom-document.sanitaryCompanyLR"
                          )
                            ? false
                            : null,
                          "data-vv-as": "nombre responsable empresa",
                          "data-cy": "sanitaryCompanyLR",
                          name: "sanitaryCompanyLR",
                          type: "text",
                          rows: "3",
                          maxLength: "1000"
                        },
                        on: {
                          input: function() {
                            return (_vm.formData.sanitaryCompanyLR = _vm.formData.sanitaryCompanyLR.toUpperCase())
                          }
                        },
                        model: {
                          value: _vm.formData.sanitaryCompanyLR,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "sanitaryCompanyLR", $$v)
                          },
                          expression: "formData.sanitaryCompanyLR"
                        }
                      }),
                      _c("div", { staticClass: "text-right" }, [
                        _c(
                          "small",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: "Contador de caracteres",
                                expression: "'Contador de caracteres'"
                              }
                            ]
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.formData.sanitaryCompanyLR.length) +
                                "/1000 "
                            )
                          ]
                        )
                      ]),
                      _vm.errors.has("custom-document.sanitaryCompanyLR")
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "con-text-validation span-text-validation-danger v-enter-to",
                              staticStyle: { height: "19px" }
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "span-text-validation" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.errors.first(
                                          "custom-document.sanitaryCompanyLR"
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-md-6 col-12" },
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "Fono *" } },
                    [
                      _c("b-form-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: { required: true, regex: _vm.phoneRegex },
                            expression: "{ required: true, regex: phoneRegex }"
                          }
                        ],
                        attrs: {
                          autocomplete: "off",
                          placeholder: "Utilice el formato +56912345678",
                          state: _vm.errors.has("custom-document.phone")
                            ? false
                            : null,
                          "data-vv-as": "fono",
                          "data-cy": "phone",
                          name: "phone",
                          type: "text",
                          pattern: "^[+][0-9]{10,11}$"
                        },
                        model: {
                          value: _vm.formData.phone,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "phone", $$v)
                          },
                          expression: "formData.phone"
                        }
                      }),
                      _vm.errors.has("custom-document.phone")
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "con-text-validation span-text-validation-danger v-enter-to",
                              staticStyle: { height: "19px" }
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "span-text-validation" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.errors.first(
                                          "custom-document.phone"
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-md-6 col-12" },
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "Email *" } },
                    [
                      _c(
                        "v-select",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          class: {
                            "v-select-danger": _vm.errors.has(
                              "custom-document.email"
                            )
                          },
                          attrs: {
                            state: _vm.errors.has("custom-document.email")
                              ? false
                              : null,
                            "data-vv-as": "email",
                            name: "email",
                            placeholder: "Busque o ingrese un nuevo email",
                            options: _vm.emailOptions,
                            taggable: "",
                            multiple: ""
                          },
                          model: {
                            value: _vm.formData.email,
                            callback: function($$v) {
                              _vm.$set(_vm.formData, "email", $$v)
                            },
                            expression: "formData.email"
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              attrs: { slot: "no-options" },
                              slot: "no-options"
                            },
                            [
                              _vm._v(
                                "No hay emails para el criterio de búsqueda"
                              )
                            ]
                          )
                        ]
                      ),
                      _vm.errors.has("custom-document.email")
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "con-text-validation span-text-validation-danger v-enter-to",
                              staticStyle: { height: "19px" }
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "span-text-validation" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.errors.first(
                                          "custom-document.email"
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-md-6 col-12" },
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "Fecha inicio *" } },
                    [
                      _c("datetime", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass: "w-100",
                        attrs: {
                          "input-class": {
                            "form-control": true,
                            "border-danger": _vm.errors.has(
                              "custom-document.startDate"
                            )
                          },
                          placeholder: "AAAA-MM-DD",
                          "data-vv-as": "fecha inicio",
                          "data-cy": "startDate",
                          name: "startDate",
                          phrases: { ok: "Seleccionar", cancel: "Cancelar" },
                          "value-zone": "local",
                          format: "yyyy-MM-dd"
                        },
                        on: {
                          input: function($event) {
                            return _vm.setEndDate($event)
                          }
                        },
                        model: {
                          value: _vm.formData.startDate,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "startDate", $$v)
                          },
                          expression: "formData.startDate"
                        }
                      }),
                      _vm.errors.has("custom-document.startDate")
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "con-text-validation span-text-validation-danger v-enter-to",
                              staticStyle: { height: "19px" }
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "span-text-validation" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.errors.first(
                                          "custom-document.startDate"
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-md-6 col-12" },
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "Fecha término *" } },
                    [
                      _c("datetime", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass: "w-100",
                        attrs: {
                          "input-class": {
                            "form-control": true,
                            "border-danger": _vm.errors.has(
                              "custom-document.endDate"
                            )
                          },
                          placeholder: "AAAA-MM-DD",
                          state: _vm.errors.has("custom-document.endDate")
                            ? false
                            : null,
                          "data-vv-as": "fecha término",
                          "data-cy": "endDate",
                          name: "endDate",
                          phrases: { ok: "Seleccionar", cancel: "Cancelar" },
                          "value-zone": "local",
                          format: "yyyy-MM-dd",
                          "min-datetime": _vm.formData.startDate
                        },
                        model: {
                          value: _vm.formData.endDate,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "endDate", $$v)
                          },
                          expression: "formData.endDate"
                        }
                      }),
                      _vm.errors.has("custom-document.endDate")
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "con-text-validation span-text-validation-danger v-enter-to",
                              staticStyle: { height: "19px" }
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "span-text-validation" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.errors.first(
                                          "custom-document.endDate"
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-md-6 col-12" },
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "Hora inicio *" } },
                    [
                      _c("datetime", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass: "w-100",
                        attrs: {
                          "input-class": {
                            "form-control": true,
                            "border-danger": _vm.errors.has(
                              "custom-document.startTime"
                            )
                          },
                          placeholder: "HH:MM",
                          state: _vm.errors.has("custom-document.startTime")
                            ? false
                            : null,
                          "data-vv-as": "hora inicio",
                          "data-cy": "startTime",
                          name: "startTime",
                          title: "Hora inicio",
                          type: "time",
                          phrases: { ok: "Seleccionar", cancel: "Cancelar" },
                          "value-zone": "local"
                        },
                        model: {
                          value: _vm.formData.startTime,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "startTime", $$v)
                          },
                          expression: "formData.startTime"
                        }
                      }),
                      _vm.errors.has("custom-document.startTime")
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "con-text-validation span-text-validation-danger v-enter-to",
                              staticStyle: { height: "19px" }
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "span-text-validation" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.errors.first(
                                          "custom-document.startTime"
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-md-6 col-12" },
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "Hora término *" } },
                    [
                      _c("datetime", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass: "w-100",
                        attrs: {
                          "input-class": {
                            "form-control": true,
                            "border-danger": _vm.errors.has(
                              "custom-document.endTime"
                            )
                          },
                          placeholder: "HH:MM",
                          state: _vm.errors.has("custom-document.endTime")
                            ? false
                            : null,
                          "data-vv-as": "hora término",
                          "data-cy": "endTime",
                          name: "endTime",
                          title: "Hora inicio",
                          type: "time",
                          phrases: { ok: "Seleccionar", cancel: "Cancelar" },
                          "value-zone": "local"
                        },
                        model: {
                          value: _vm.formData.endTime,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "endTime", $$v)
                          },
                          expression: "formData.endTime"
                        }
                      }),
                      _vm.errors.has("custom-document.endTime")
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "con-text-validation span-text-validation-danger v-enter-to",
                              staticStyle: { height: "19px" }
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "span-text-validation" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.errors.first(
                                          "custom-document.endTime"
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _c("div", { staticClass: "col-md-12" }, [_c("vs-divider")], 1),
            _c("h4", [_vm._v("Identificación de participantes")]),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "SiSS *" } },
                    [
                      _c("UsersList", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: { required: _vm.formData.siss.length <= 0 },
                            expression:
                              "{ required: formData.siss.length <= 0 }"
                          }
                        ],
                        staticClass: "w-100 mb-0",
                        attrs: {
                          state: _vm.errors.has("custom-document.siss")
                            ? false
                            : null,
                          danger: _vm.errors.has("custom-document.siss"),
                          "danger-text": _vm.errors.first(
                            "custom-document.siss"
                          ),
                          "data-cy": "siss",
                          "data-vv-as": "siss",
                          placeholder: "Busca a un usuario para agregar...",
                          "is-clearable": false,
                          label: "",
                          autocomplete: "",
                          name: "siss",
                          "is-multiple": true
                        },
                        on: {
                          input: function($event) {
                            return _vm.setFunctionaries($event)
                          }
                        },
                        model: {
                          value: _vm.formData.siss,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "siss", $$v)
                          },
                          expression: "formData.siss"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "SANITARIA *" } },
                    [
                      _c("b-form-textarea", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: {
                          state: _vm.errors.has("custom-document.sanitary")
                            ? false
                            : null,
                          name: "sanitary",
                          "data-cy": "sanitary",
                          "data-vv-as": "sanitaria",
                          type: "text",
                          rows: "3",
                          maxLength: "1000"
                        },
                        on: {
                          input: function() {
                            return (_vm.formData.sanitary = _vm.formData.sanitary.toUpperCase())
                          }
                        },
                        model: {
                          value: _vm.formData.sanitary,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "sanitary", $$v)
                          },
                          expression: "formData.sanitary"
                        }
                      }),
                      _c("div", { staticClass: "text-right" }, [
                        _c(
                          "small",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: "Contador de caracteres",
                                expression: "'Contador de caracteres'"
                              }
                            ]
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.formData.sanitary.length) +
                                "/1000 "
                            )
                          ]
                        )
                      ]),
                      _vm.errors.has("custom-document.sanitary")
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "con-text-validation span-text-validation-danger v-enter-to",
                              staticStyle: { height: "19px" }
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "span-text-validation" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.errors.first(
                                          "custom-document.sanitary"
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _c("div", { staticClass: "col-md-12" }, [_c("vs-divider")], 1),
            _c("h4", [_vm._v("Motivo de la fiscalización")]),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "Motivo de la fiscalización *" } },
                    [
                      _c("b-form-textarea", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: {
                          state: _vm.errors.has("custom-document.reason")
                            ? false
                            : null,
                          name: "reason",
                          "data-cy": "reason",
                          "data-vv-as": "motivo fiscalización",
                          type: "text",
                          rows: "3",
                          maxLength: "5000"
                        },
                        model: {
                          value: _vm.formData.reason,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "reason", $$v)
                          },
                          expression: "formData.reason"
                        }
                      }),
                      _c("div", { staticClass: "text-right" }, [
                        _c(
                          "small",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: "Contador de caracteres",
                                expression: "'Contador de caracteres'"
                              }
                            ]
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.formData.reason.length) +
                                "/5000 "
                            )
                          ]
                        )
                      ]),
                      _vm.errors.has("custom-document.reason")
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "con-text-validation span-text-validation-danger v-enter-to",
                              staticStyle: { height: "19px" }
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "span-text-validation" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.errors.first(
                                          "custom-document.reason"
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label:
                          "Observaciones fiscalización / situaciones constatadas *"
                      }
                    },
                    [
                      _c("b-form-textarea", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: {
                          state: _vm.errors.has("custom-document.reason")
                            ? false
                            : null,
                          name: "observations",
                          "data-cy": "observations",
                          "data-vv-as": "obs. fiscalización/sit. constatadas",
                          type: "text",
                          rows: "3",
                          maxLength: "16000"
                        },
                        model: {
                          value: _vm.formData.observations,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "observations", $$v)
                          },
                          expression: "formData.observations"
                        }
                      }),
                      _c("div", { staticClass: "text-right" }, [
                        _c(
                          "small",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: "Contador de caracteres",
                                expression: "'Contador de caracteres'"
                              }
                            ]
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.formData.observations.length) +
                                "/16000 "
                            )
                          ]
                        )
                      ]),
                      _vm.errors.has("custom-document.observations")
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "con-text-validation span-text-validation-danger v-enter-to",
                              staticStyle: { height: "19px" }
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "span-text-validation" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.errors.first(
                                          "custom-document.observations"
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            !!_vm.error.message
              ? _c(
                  "div",
                  {
                    staticClass:
                      "con-text-validation span-text-validation-danger\n            vs-input--text-validation-span v-enter-to text-right"
                  },
                  [
                    _c("span", { staticClass: "span-text-validation" }, [
                      _vm._v(" " + _vm._s(_vm.error.message) + " ")
                    ])
                  ]
                )
              : _vm._e(),
            _c("div", [
              _c(
                "div",
                { staticClass: "row align-items-center mt-5" },
                [
                  _vm._m(0),
                  _c(
                    "div",
                    { staticClass: "col-md-3 align-items-end" },
                    [
                      _c("UploadFile", {
                        attrs: {
                          permission: "*",
                          accept: "application/pdf, .doc, .docx, .xlsx, .ppt",
                          text: "Seleccionar documentos",
                          "upload-to": "ed",
                          "button-class": {
                            "btn-block": true,
                            "mb-5": _vm.errors.has("custom-document.fileName")
                          },
                          "container-class": "w-100"
                        },
                        on: {
                          input: function($event) {
                            return _vm.addOthersFile()
                          }
                        },
                        model: {
                          value: _vm.fileOthers,
                          callback: function($$v) {
                            _vm.fileOthers = $$v
                          },
                          expression: "fileOthers"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._l(_vm.formData.attachments, function(file) {
                    return _c("div", { key: file.id, staticClass: "col-3" }, [
                      _c(
                        "div",
                        {
                          staticClass: "d-flex flex-column align-items-center"
                        },
                        [
                          _c("vs-icon", {
                            attrs: {
                              icon: "description",
                              size: "45px",
                              color: "primary"
                            }
                          }),
                          _c(
                            "b",
                            { staticClass: "text-truncate w-100 text-center" },
                            [_vm._v(_vm._s(file.name))]
                          ),
                          _c("vs-button", {
                            attrs: {
                              color: "danger",
                              type: "flat",
                              icon: "clear"
                            },
                            on: {
                              click: function($event) {
                                return _vm.removeOthersFile(file.id)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ])
                  }),
                  _c("div", { staticClass: "col-md-12" }, [
                    !!_vm.error.messageOthers
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "con-text-validation span-text-validation-danger\n            vs-input--text-validation-span v-enter-to text-left"
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "span-text-validation" },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.error.messageOthers) + " "
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                ],
                2
              )
            ])
          ]
        ),
        _c(
          "div",
          { staticClass: "row justify-end" },
          [
            _c(
              "vs-button",
              {
                staticClass: "mt-5 mr-5",
                attrs: {
                  "data-cy": "cancel",
                  color: "primary",
                  disabled: _vm.saving
                },
                on: {
                  click: function($event) {
                    return _vm.back()
                  }
                }
              },
              [_vm._v(" Cancelar ")]
            ),
            _c(
              "vs-button",
              {
                staticClass: "mt-5 mr-5",
                attrs: {
                  "data-cy": "preview",
                  color: "warning",
                  disabled: _vm.saving
                },
                on: {
                  click: function($event) {
                    return _vm.preview()
                  }
                }
              },
              [
                _vm._v(" Previsualizar "),
                _c("span", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.saving,
                      expression: "saving"
                    }
                  ],
                  staticClass: "spinner-border spinner-border-sm text-primary"
                })
              ]
            ),
            _c(
              "vs-button",
              {
                staticClass: "mt-5 mr-5",
                attrs: {
                  "data-cy": "save",
                  color: "success",
                  disabled: _vm.saving
                },
                on: {
                  click: function($event) {
                    return _vm.save()
                  }
                }
              },
              [
                _vm._v(" Crear "),
                _c("span", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.saving,
                      expression: "saving"
                    }
                  ],
                  staticClass: "spinner-border spinner-border-sm text-primary"
                })
              ]
            )
          ],
          1
        )
      ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("label", [_vm._v("Adjuntar documentos")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }